import React, { Component } from 'react';
import Unsubscribe from '../components/Home/Unsubscribe';

class UnsubscribeHome extends Component {
    render() {
        return (
            <React.Fragment>
              <Unsubscribe />
            </React.Fragment>
        );
    }
}

export default UnsubscribeHome;
